import React, { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { DatePickerModal } from 'react-native-paper-dates';
import { TextInput } from './TextInput';

type Props = {
  label: string;
  showLabel?: boolean;
  value?: Date;
  onChange: (date: Date) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  minimumDate?: Date;
  maximumDate?: Date;
  testID?: string;
};

export function DateInput({
  label,
  showLabel = true,
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  minimumDate,
  maximumDate,
  testID,
}: Props) {
  const [showPicker, setShowPicker] = useState(false);

  const formatDisplayValue = (): string => {
    if (!value) return '';
    return value.toLocaleDateString();
  };

  const handleConfirm = ({ date }: { date?: Date }) => {
    if (date) {
      onChange(date);
    }
    setShowPicker(false);
  };

  const handlePress = () => {
    if (!disabled) {
      setShowPicker(true);
    }
  };

  return (
    <View style={styles.container}>
      <Pressable onPress={handlePress} disabled={disabled}>
        <TextInput
          label={label}
          showLabel={showLabel}
          value={formatDisplayValue()}
          placeholder={placeholder ?? 'Select date'}
          editable={false}
          pointerEvents="none"
          error={error}
          testID={testID}
          dense={true}
        />
      </Pressable>

      <DatePickerModal
        locale="en"
        mode="single"
        visible={showPicker}
        onDismiss={() => setShowPicker(false)}
        date={value}
        onConfirm={handleConfirm}
        validRange={{
          startDate: minimumDate,
          endDate: maximumDate,
        }}
        presentationStyle="pageSheet"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});
